import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainingIndexComponent } from './crud-index/crud-index.component';
import { TrainingCESComponent } from './crud-ces/crud-ces.component';
import { TrainingIndexSelectComponent } from './crud-index/crud-index-select.component';
import { TrainingCrudIndex } from './crud-index/crud-index';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { TableResponsiveTrainingsModule } from 'src/app/shared/components/table-responsive-trainings/table-responsive-trainings.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { FileDescriptionComponent } from './file-description/file-description.component';
import { TrainingsRoutingModule } from './trainings-routing.module';
import { FileViewerDialogComponent } from './file-viewer-dialog/file-viewer-dialog.component';
import { SafeUrlPipe } from './safe-url.pipe';
import { UnsupportedFileDialogComponent } from './unsupported-file-dialog/unsupported-file-dialog.component';

@NgModule({
  declarations: [
    TrainingCESComponent,
    TrainingCrudIndex,
    TrainingIndexComponent,
    TrainingIndexSelectComponent,
    FileDescriptionComponent,
    FileViewerDialogComponent,
    SafeUrlPipe,
    UnsupportedFileDialogComponent, // Declarando o pipe SafeUrlPipe
  ],
  imports: [
    CommonModule,
    TrainingsRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    TableResponsiveTrainingsModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
  ],
  exports: [
    TrainingCESComponent, // Exporte os componentes se eles precisarem ser usados fora do módulo
    TrainingIndexComponent,
    FileViewerDialogComponent,
    SafeUrlPipe,
  ]
})
export class TrainingsModule { }
